import React from 'react'
import PropTypes from 'prop-types'
import { ContentLoader, FormInput, Margin, Text } from 'shared/components'
import { EditableFormPanel } from 'routes/shared/components'
import { dateWithTime } from 'constants/dateFormats'

import * as styles from './styles'

const TimemachineComponent = ({ form, loading, onSubmitRequest }) => (
  <ContentLoader loading={loading}>
    <EditableFormPanel
      header="Time Machine Configuration"
      form={form}
      onSubmit={onSubmitRequest}
    >
      {(editable) => {
        const disabled = !editable

        return (
          <>
            <Margin bottom={1} css={styles.row}>
              <Text as="label" size={16}>
                Custom Date
              </Text>
              <FormInput
                strictLong
                name="customDate"
                type="date"
                showTimeInput
                showYearDropdown
                dateFormat={dateWithTime}
                placeholder="MM/dd/yyyy HH:mm"
                css={styles.control}
                disabled={disabled}
              />
            </Margin>
            <Margin bottom={1} css={styles.row}>
              <Text as="label" size={16}>
                Effective Date
              </Text>
              <FormInput
                strictLong
                name="effectiveDate"
                placeholder="N/A"
                css={styles.control}
                disabled
              />
            </Margin>
            <Margin bottom={1} css={styles.row}>
              <Text as="label" size={16}>
                When Custom Date Set
              </Text>
              <FormInput
                strictLong
                name="serverDateWhenCustomDateSet"
                placeholder="N/A"
                css={styles.control}
                disabled
              />
            </Margin>
            <Margin bottom={1} css={styles.row}>
              <Text as="label" size={16}>
                Activate Scheduler
              </Text>
              <FormInput
                strictLong
                name="schedulerEnabled"
                type="toggle"
                css={styles.control}
                disabled={disabled}
              />
            </Margin>
          </>
        )
      }}
    </EditableFormPanel>
  </ContentLoader>
)

TimemachineComponent.propTypes = {
  form: PropTypes.shape(),
  onSubmitRequest: PropTypes.func,
  loading: PropTypes.bool,
}

export default TimemachineComponent
